import React from 'react'
import HomeBanner from './home/HomeBanner'
import Opportunities from './home/Opportunities'
import MissionVision from './home/MissionVision'
import HomeAbout from './home/HomeAbout'
import HomeReviews from './home/HomeReviews'
import HomeGallery from './home/HomeGallery'
import HomeBlog from './home/HomeBlog'
import OurTeam from './home/OurTeam'
import HomeTopResult from './home/HomeTopResult'
import NewsAdvertisement from './home/NewsAdvertisement'

const Home = () => {
  return (
    <>

      
      <HomeBanner />
      <HomeAbout />
      <MissionVision />
      <OurTeam />
      <Opportunities />  {/* Why Choose Us */}
      <HomeGallery />
      <HomeReviews />
      <HomeBlog />
      {/* <NewsAdvertisement /> */}
      <HomeTopResult />




    </>
  )
}

export default Home